import { useSearchParams } from "react-router-dom";
import React from "react";
export function useFloorplanFilters(callbacks) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var _j = useSearchParams(), searchParams = _j[0], setSearchParams = _j[1];
    var batchedUpdatesRef = React.useRef();
    var pendingUpdatesRef = React.useRef(new URLSearchParams(searchParams.toString()));
    var filters = {
        bedrooms: (_a = searchParams.get("bedrooms")) !== null && _a !== void 0 ? _a : undefined,
        bathrooms: (_b = searchParams.get("bathrooms")) !== null && _b !== void 0 ? _b : undefined,
        unitSizeMin: (_c = searchParams.get("unitSizeMin")) !== null && _c !== void 0 ? _c : undefined,
        unitSizeMax: (_d = searchParams.get("unitSizeMax")) !== null && _d !== void 0 ? _d : undefined,
        priceMin: (_e = searchParams.get("priceMin")) !== null && _e !== void 0 ? _e : undefined,
        priceMax: (_f = searchParams.get("priceMax")) !== null && _f !== void 0 ? _f : undefined,
        availableDate: (_g = searchParams.get("availableDate")) !== null && _g !== void 0 ? _g : undefined,
        floorplanType: (_h = searchParams.get("floorplanType")) !== null && _h !== void 0 ? _h : undefined,
    };
    var setFilter = function (key, value) {
        if (value !== undefined && value !== "") {
            pendingUpdatesRef.current.set(key, value);
        }
        else {
            pendingUpdatesRef.current.delete(key);
        }
        if (batchedUpdatesRef.current) {
            clearTimeout(batchedUpdatesRef.current);
        }
        batchedUpdatesRef.current = setTimeout(function () {
            setSearchParams(pendingUpdatesRef.current, { replace: true });
        }, 0);
    };
    var resetFilters = function () {
        var _a;
        pendingUpdatesRef.current = new URLSearchParams();
        setSearchParams(new URLSearchParams());
        (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onReset) === null || _a === void 0 ? void 0 : _a.call(callbacks);
    };
    React.useEffect(function () {
        return function () {
            if (batchedUpdatesRef.current) {
                clearTimeout(batchedUpdatesRef.current);
            }
        };
    }, []);
    return { filters: filters, setFilter: setFilter, resetFilters: resetFilters };
}
